import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "table align-middle fs-6 gy-5" }
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_11 = { class: "d-flex gap-4 align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "badge text-bg-warning me-1"
}

import { ref, onMounted } from "vue";
import EventV2Services from "../services/EventV2Services";
import { EventShopItemStatusTypes } from "@/core/types/shop/ShopItemTypes";
import { ElNotification } from "element-plus";
import { ConfigSiteTypesSelections } from "@/core/types/SiteTypes";
import CreateEventV2 from "../components/CreateEventV2.vue";
import EditEventV2 from "../components/EditEventV2.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EventV2Index',
  setup(__props) {

const isLoading = ref(false);
const createEventRef = ref<InstanceType<typeof CreateEventV2>>();
const editEventRef = ref<InstanceType<typeof EditEventV2>>();
const data = ref<any[]>([]);
const criteria = ref({ page: 1, size: 25 });

const typeTagStyle: Record<number, { label: string; tagType: string }> = {
  0: { label: "Normal", tagType: "" },
  1: { label: "Popup", tagType: "warning" },
  2: { label: "Header", tagType: "success" },
};

const fetchData = async (page: number) => {
  isLoading.value = true;
  criteria.value.page = page;
  try {
    const res = await EventV2Services.queryEventsList(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};

const publishToggle = async (item: any) => {
  try {
    if (item.status === EventShopItemStatusTypes.Published) {
      await EventV2Services.publishEvent(item.id);
      ElNotification({
        title: "Success",
        message: "Event published",
        type: "success",
      });
    } else {
      await EventV2Services.unpublishEvent(item.id);
      ElNotification({
        title: "Success",
        message: "Event unpublished",
        type: "success",
      });
    }
  } catch {
    ElNotification({
      title: "Error",
      message: "Failed to update event status",
      type: "error",
    });
  }
};

onMounted(() => fetchData(1));

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("title.eventsV2")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (createEventRef.value.show()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.new")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_7, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("tip.published")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.eventId")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.title")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.key")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.eventType")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accessRoles")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.site")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.startDate")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.endDate")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && data.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_11, [
                      _createVNode(_component_el_switch, {
                        modelValue: item.status,
                        "onUpdate:modelValue": ($event: any) => ((item.status) = $event),
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                        "active-value": _unref(EventShopItemStatusTypes).Published,
                        onClick: ($event: any) => (publishToggle(item))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "active-value", "onClick"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", null, _toDisplayString(item.title), 1),
                    _createElementVNode("td", null, _toDisplayString(item.key), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_tag, {
                        type: typeTagStyle[item.type]?.tagType ?? ''
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(typeTagStyle[item.type]?.label ?? "Normal"), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    _createElementVNode("td", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.accessRoles, (role, i) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          key: i,
                          type: "warning",
                          size: "small",
                          class: "me-1",
                          effect: "dark"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(role), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _createElementVNode("td", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (s, i) => {
                        return (_openBlock(), _createElementBlock("span", { key: i }, [
                          (item.accessSites.includes(String(s.value)))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(s.label), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        type: "GMToneLiner",
                        "date-iso-string": item.startOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        type: "GMToneLiner",
                        "date-iso-string": item.endOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: ($event: any) => (editEventRef.value.show(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(_component_TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _createVNode(CreateEventV2, {
      ref_key: "createEventRef",
      ref: createEventRef,
      onSubmit: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1)))
    }, null, 512),
    _createVNode(EditEventV2, {
      ref_key: "editEventRef",
      ref: editEventRef,
      onSubmit: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1)))
    }, null, 512)
  ]))
}
}

})